<template>
  <div>
    <ul class="list">
      <li v-for="tag in tags" :key="tag.id" class="list__item">
        <TagItem :name="tag.name" />
      </li>
    </ul>
  </div>
</template>

<script>
import TagItem from './TagItem.vue';

export default {
  name: 'TagList',
  components: {
    TagItem,
  },
  props: {
    tags: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  $gutter: 5px;

  display: flex;
  flex-wrap: wrap;

  margin-top: -$gutter;
  margin-left: -$gutter;

  &__item {
    margin-top: $gutter;
    margin-left: $gutter;
  }
}
</style>
